module.exports = __webpack_public_path__ + "img/logo-new.1c914338.jpg";